
import SETTINGS from 'settings'

export default function( space )
{
    if ( window.location.href.indexOf( 'facebook.com' ) < 0 )
    {
        space.s( 'facebook_load' ).next( true )
        return
    }
    SETTINGS.under_facebook = true
    
    //has to be in index.html anyway:
    /*$.ajaxSetup({ cache : true })
    $.getScript(
        'https://connect.facebook.net/en_US/fbinstant.6.2.js',
        () => FBInstant.initializeAsync().then( () => space.s( 'facebook_load' ).next( true ) )
    )*/
    
    space.s( 'facebook_load' ).on( () => console.log( 'Facebook player ID:', FBInstant.player.getID() ) )
}







// WEBPACK FOOTER //
// ./src/library/social/facebook.es6